import { deserializeSuperjson, SuperJSONResult } from '@lib/superjson';
import {
  CreateSnapOperationAttachmentOutput,
  CreateSnapOperationAttachmentRequest,
} from '@snap-types/actions/create-snap-operation-attachment';
import {
  DeleteSnapOperationAttachmentOutput,
  DeleteSnapOperationAttachmentRequest,
} from '@snap-types/actions/delete-snap-operation-attachment';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';

import type { API } from './api';

export class OperationAttachmentService {
  constructor(private api: API) {}

  createAttachment = async ({
    params,
    body,
  }: CreateSnapOperationAttachmentRequest) => {
    const url = buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteVersionUuid,
      `attachments/${params.stepId}`,
    );

    const response = await this.api.postFile<SuperJSONResult>(url, body);

    return deserializeSuperjson<CreateSnapOperationAttachmentOutput>(response);
  };

  deleteAttachment = async ({
    params,
  }: DeleteSnapOperationAttachmentRequest) => {
    const url = buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteVersionUuid,
      `attachments/${params.stepId}/${params.documentUuid}`,
    );

    const response =
      await this.api.delete<DeleteSnapOperationAttachmentOutput>(url);

    return response;
  };
}
